import { debounce } from 'lodash';
import { useContext, useMemo } from 'react';
import { input } from './events';
import { SearchPageContext } from './types';

const MAX_SAVED_SEARCHES = 5;
const SAVED_SEARCHES_LOCAL_STORAGE_KEY = 'SavedSearches';

const shouldSaveSearchQuery = (savedSearches: string[], searchQuery: string) => {
  if (savedSearches.indexOf(searchQuery) === -1 && searchQuery.length > 1) {
    return true;
  } else {
    return false;
  }
};

export const getSavedSearches = () => {
  const stringifiedSavedSearches =
    window.localStorage.getItem(SAVED_SEARCHES_LOCAL_STORAGE_KEY) || '[]';
  return JSON.parse(stringifiedSavedSearches);
};

const setSavedSearches = (savedSearches: string[]) => {
  const stringifiedSavedSearches = JSON.stringify(
    savedSearches.slice(0, MAX_SAVED_SEARCHES),
  );
  window.localStorage.setItem(SAVED_SEARCHES_LOCAL_STORAGE_KEY, stringifiedSavedSearches);
};

export const updateSavedSearches = (searchQuery?: string) => {
  if (!searchQuery) {
    return;
  }
  const lowercasedSearchQuery = searchQuery?.toLowerCase();
  const savedSearches = getSavedSearches();

  if (shouldSaveSearchQuery(savedSearches, lowercasedSearchQuery)) {
    savedSearches.unshift(lowercasedSearchQuery);
  }

  setSavedSearches(savedSearches);
};

/**
 * Debounces text input to limit # of XHR requests.
 * @returns a debounced callback for text input.
 */
export const useSearchInput = () => {
  const { dispatch } = useContext(SearchPageContext);

  return useMemo(
    () =>
      debounce((value: string) => {
        dispatch(input(value));
      }, 400),
    [dispatch],
  );
};

export const useDebouncedSavedSearch = () => {
  return useMemo(() => debounce((value?: string) => updateSavedSearches(value), 800), [
    updateSavedSearches,
  ]);
};
